module.exports = __webpack_public_path__ + "static/Montserrat-Regular-kern-latin-c960493e5439bae7ffe54e403c56f1c7.woff2";